import React, {useEffect, useState} from 'react'
import Api, {postApi} from '../Api';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import {useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItem, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {AddBoxOutlined, CheckOutlined, DeleteOutlined} from "@mui/icons-material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import moment from "moment";

const ActivitySettings = () => {
    const [status, setStatus] = useState({id:0, status_name:''})
    const [statuses, setStatuses] = useState([]);
    const [modalAddStatusOpen, setModalAddStatusOpen] = useState(false)
    const [newStatusName, setNewStatusName] = useState('');
    const [coeff, setCoeff] = useState([]);
    const permission = useSelector((state) => state.permissions.value)


    const getStatuses = async () => {
        setStatuses(await Api('admin/activity/get-status-list'));
    }
    const getCoeff = async () => {
        if (status.id > 1) {
            setCoeff(await Api(`admin/activity/get-status-time-coefficients/${status.id}`));
        }
    }
    const updateStatusName = () => {
        postApi('admin/activity/change-status', status).then(getStatuses);
    }
    const handleStatusNameChange = (e) => {
        let nstatus = structuredClone(status)
        nstatus.status_name = e.target.value;
        setStatus(nstatus);
    }
    const addNewStatus = () => {
        let data = {id:0, status_name:newStatusName, undeletable: 0};
        postApi('admin/activity/add-status', data).then(()=>{
            setNewStatusName('');
            setModalAddStatusOpen(false);
        }).then(getStatuses);
    }
    const deleteStatus = (id) => {
        postApi('admin/activity/delete-status', {id:id, status_name:'', undeletable: 0}).then(getStatuses);
    }
    const getCF = hour => {
        for (let c of coeff){
            if(c.c_hour === hour) return c.time_coefficient;
        }
        return 1;
    }
    const rebuildCF = hour => event => {
        let nc = structuredClone(coeff);
        let hasValue = false;
        for(let c of nc){
            if(c.c_hour === hour){
                c.time_coefficient = event.target.value;
                hasValue = true;
            }
        }
        if(!hasValue){
            nc.push({c_hour: hour, time_coefficient: event.target.value, status_id: status.id});
        }
        setCoeff(nc);
    }
    const saveCfTable = async () => {
        let hc = {}
        for (let c of coeff) {
            hc[c.c_hour] = c.time_coefficient;
        }
        for (let h of Array(24).keys()){
            let cf = {id: 0, c_hour: h, time_coefficient: hc[h] ? hc[h] : '1', status_id: status.id};
            await postApi('admin/activity/change-status-time-coefficient', cf)
        }
        getCoeff();
    }
    useEffect(() => {
        getStatuses()
    },[])
    useEffect(() => {
        getCoeff()
    }, [status]);
    return <Box>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <Box sx={{display: 'flex', width: '100%'}} component={'div'}>
                <Box sx={{ marginLeft: 2, flexGrow: 1, display: { md: 'flex' } }}>
                    <Typography variant={'h5'} sx={{p:2}}>Настройка системы активностей</Typography>
                </Box>
            </Box>
        </Paper>
        {permission.indexOf('manage_activity_status') > -1 &&
        <Grid container spacing={2} sx={{mt:1}}>
            <Grid item xs={4}>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <Box sx={{display: 'flex', width: '100%'}} component={'div'}>
                        <Box sx={{ marginLeft: 2, flexGrow: 1, display: { md: 'flex' } }}>
                            <Typography variant={'h5'} sx={{p:2}}>Статусы</Typography>
                        </Box>
                        {status.id > 0 &&
                            <Box sx={{ flexGrow: 0, p:2 }}>
                                <TextField size={'small'} value={status.status_name} onChange={handleStatusNameChange}/>
                                <IconButton variant={'contained'} color={'success'} onClick={updateStatusName}>
                                    <CheckOutlined/>
                                </IconButton>
                            </Box>
                        }
                        <Box sx={{ flexGrow: 0, p:2 }}>
                            <IconButton variant={'outlined'} color={'primary'} onClick={()=>setModalAddStatusOpen(true)}>
                                <AddBoxOutlined/>
                            </IconButton>
                        </Box>
                    </Box>
                </Paper>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt:1 }}>
                    <List>
                        {statuses.map((i,e)=><ListItem key={`status_${e}`}
                                secondaryAction={
                                    i.undeletable !== 1 && <IconButton
                                        edge="end"
                                        color={'error'}
                                        onClick={()=>{deleteStatus(i.id)}}
                                    ><DeleteOutlined/></IconButton>
                                }
                        >
                            <ListItemButton onClick={()=>setStatus(i)}>{i.status_name}</ListItemButton>
                        </ListItem>)}
                    </List>
                </Paper>
            </Grid>
            <Grid item xs={8}>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <Box sx={{display: 'flex', width: '100%'}} component={'div'}>
                        <Box sx={{ marginLeft: 2, flexGrow: 1, display: { md: 'flex' } }}>
                            <Typography variant={'h5'} sx={{p:2}}>Коэффициенты по часам</Typography>
                        </Box>
                        <Box sx={{ flexGrow: 0, p:2 }}>
                            <IconButton variant={'outlined'} color={'primary'} onClick={saveCfTable}>
                                <CheckOutlined/>
                            </IconButton>
                        </Box>
                    </Box>
                </Paper>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt:1 }}>
                    {status.id > 1 && <Table>
                        <TableBody>
                        {Array(24).fill(null).map((_,e)=><TableRow key={`hrs_${e}`}>
                                        <TableCell>{moment({hour: e}).format('HH:mm')}</TableCell>
                                        <TableCell>
                                            <TextField size={'small'} value={getCF(e)} onChange={rebuildCF(e)}></TextField>
                                        </TableCell>
                                    </TableRow>)}
                        </TableBody>
                    </Table>
                    }
                    {status.id === 1 &&  <Box sx={{display: 'flex', width: '100%'}} component={'div'}>
                        <Box sx={{ marginLeft: 2, flexGrow: 1, display: { md: 'flex' } }}>
                            <Typography variant={'body1'} sx={{p:2}}>Для данного статуса не предусмотрена таблица коэффициентов</Typography>
                        </Box>
                    </Box>}
                    {status.id === 0 &&  <Box sx={{display: 'flex', width: '100%'}} component={'div'}>
                        <Box sx={{ marginLeft: 2, flexGrow: 1, display: { md: 'flex' } }}>
                            <Typography variant={'body1'} sx={{p:2}}>Выберите статус</Typography>
                        </Box>
                    </Box>}
                </Paper>
            </Grid>
            <Dialog
                open={modalAddStatusOpen}
                onClose={()=>{setModalAddStatusOpen(false)}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Добавление нового статуса"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        Введите название нового статуса
                        <TextField fullWidth value={newStatusName} placeholder="Введите название нового статуса" onChange={(e)=>{setNewStatusName(e.target.value)}}/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{setModalAddStatusOpen(false)}} color={'info'} variant={'contained'} autoFocus>Я передумал</Button>
                    <Button onClick={addNewStatus} color={'error'} variant={'contained'}>
                        Добавить
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
        }
    </Box>
}
export default ActivitySettings